import { cn } from "@/lib/utils/index";

function Skeleton({ className, ...props }) {
  return (
    <div
      data-slot="skeleton"
      className={cn(
        "relative overflow-hidden rounded-radius bg-slate-200/80 dark:bg-muted/60",
        className,
      )}
      {...props}
    >
      <div
        aria-hidden="true"
        className="pointer-events-none absolute inset-0 bg-gradient-to-r from-transparent via-white/70 to-transparent dark:via-white/10"
        style={{ animation: "app-skeleton-shimmer 1.4s ease-in-out infinite" }}
      />
    </div>
  );
}

export { Skeleton };
